/**
 * AONA INDIA — Quick View Modal Script
 * Gilded Heritage Design — Responsive Quick View Modal Manager
 */

(function () {
  'use strict';

  var modal          = null;
  var backdrop       = null;
  var closeBtn       = null;
  var loading        = null;
  var content        = null;
  var imgEl          = null;
  var thumbsEl       = null;
  var titleEl        = null;
  var colEl          = null;
  var reviewsLink    = null;
  var priceMainEl    = null;
  var priceCompareEl = null;
  var discountPillEl = null;
  var descEl         = null;
  var variantsEl     = null;
  var variantIdEl    = null;
  var pinInputEl     = null;
  var pinBtnEl       = null;
  var pinEtaEl       = null;
  var qtyMinusBtn    = null;
  var qtyPlusBtn     = null;
  var qtyValEl       = null;
  var atcBtn         = null;
  var buyNowBtn      = null;
  var fullLinkEl     = null;

  var currentProduct = null;
  var currentVariant = null;
  var currentQty     = 1;

  /* ── OPEN ── */
  function open(productUrl) {
    if (!modal) init();
    currentQty = 1;
    if (qtyValEl) qtyValEl.textContent = '1';
    if (pinInputEl) pinInputEl.value = '';
    if (pinEtaEl) { pinEtaEl.hidden = true; pinEtaEl.textContent = ''; }

    showModal();
    showLoading();

    // Normalise URL
    var jsonUrl = productUrl.replace(/\.js$/, '') + '.js';
    if (!jsonUrl.startsWith('/')) jsonUrl = '/' + jsonUrl;

    fetch(jsonUrl)
      .then(function (r) {
        if (!r.ok) throw new Error('Product fetch failed');
        return r.json();
      })
      .then(function (product) {
        currentProduct = product;
        populate(product);
        showContent();
      })
      .catch(function () {
        hideModal();
      });
  }

  /* ── POPULATE ── */
  function populate(product) {
    currentVariant = product.variants[0];

    // Main Image
    if (imgEl && product.images.length) {
      imgEl.src = product.images[0];
      imgEl.alt = product.title;
    }

    // Thumbnails
    if (thumbsEl) {
      thumbsEl.innerHTML = '';
      product.images.slice(0, 5).forEach(function (img, i) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'aona-qv__thumb-btn' + (i === 0 ? ' is-active' : '');
        btn.setAttribute('aria-label', 'View image ' + (i + 1));
        var image = document.createElement('img');
        image.src = img.replace(/(\.\w+)$/, '_120x120$1');
        image.alt = '';
        image.width = 64;
        image.height = 64;
        btn.appendChild(image);
        btn.addEventListener('click', function () {
          if (imgEl) imgEl.src = img;
          thumbsEl.querySelectorAll('.aona-qv__thumb-btn').forEach(function (b) {
            b.classList.remove('is-active');
          });
          btn.classList.add('is-active');
        });
        thumbsEl.appendChild(btn);
      });
    }

    // Header & Meta
    if (titleEl) titleEl.textContent = product.title;
    if (colEl) colEl.textContent = product.type || 'Luxury Collection';
    if (descEl) {
      var tmp = document.createElement('div');
      tmp.innerHTML = product.description;
      var cleanText = tmp.textContent || tmp.innerText || '';
      descEl.textContent = cleanText.length > 180 ? cleanText.slice(0, 180) + '…' : cleanText;
    }
    if (fullLinkEl) fullLinkEl.href = '/products/' + product.handle;
    if (reviewsLink) reviewsLink.href = '/products/' + product.handle + '#reviews';

    // Pricing & Discount
    updatePricing(currentVariant);

    // Variant ID
    if (variantIdEl) variantIdEl.value = currentVariant.id;

    // Variants
    buildVariants(product);

    // ATC state
    updateATC(currentVariant);
  }

  /* ── VARIANTS ── */
  function buildVariants(product) {
    if (!variantsEl) return;
    variantsEl.innerHTML = '';
    
    var isSingleDefault = product.options.length === 1 && (
      product.options[0] === 'Title' || 
      (product.options[0] && product.options[0].name === 'Title')
    );
    if (!product.options || isSingleDefault) return;

    product.options.forEach(function (optItem, optIdx) {
      var optName = typeof optItem === 'string' ? optItem : optItem.name;
      optName = optName || 'Option';
      var values = [];
      product.variants.forEach(function (v) {
        var val = v.options[optIdx];
        if (values.indexOf(val) === -1) values.push(val);
      });

      var group = document.createElement('div');
      group.className = 'aona-qv__opt-group';

      var label = document.createElement('p');
      label.className = 'aona-qv__opt-label';
      label.innerHTML = optName + ': <span class="aona-qv__opt-val">' + (product.variants[0].options[optIdx]) + '</span>';
      group.appendChild(label);

      var optLower = optName.toLowerCase();
      var isColor = optLower === 'color' || optLower === 'colour' || optLower === 'finish' || optLower === 'material';

      var row = document.createElement('div');
      row.className = isColor ? 'aona-qv__swatches' : 'aona-qv__chips';
      group.appendChild(row);

      values.forEach(function (val, i) {
        var chip = document.createElement('button');
        chip.type = 'button';
        chip.className = (isColor ? 'aona-qv__swatch' : 'aona-qv__chip') + (i === 0 ? ' is-active' : '');
        chip.textContent = val;
        chip.addEventListener('click', function () {
          row.querySelectorAll('.' + (isColor ? 'aona-qv__swatch' : 'aona-qv__chip')).forEach(function (c) {
            c.classList.remove('is-active');
          });
          chip.classList.add('is-active');
          var valSpan = label.querySelector('.aona-qv__opt-val');
          if (valSpan) valSpan.textContent = val;
          matchVariant();
        });
        row.appendChild(chip);
      });

      variantsEl.appendChild(group);
    });
  }

  function matchVariant() {
    if (!currentProduct) return;
    var selected = [];
    variantsEl.querySelectorAll('.aona-qv__opt-group').forEach(function (g) {
      var active = g.querySelector('.is-active');
      if (active) selected.push(active.textContent.trim());
    });

    var match = currentProduct.variants.find(function (v) {
      return v.options.every(function (o, i) { return o === selected[i]; });
    });

    if (match) {
      currentVariant = match;
      if (variantIdEl) variantIdEl.value = match.id;
      updatePricing(match);
      updateATC(match);
      if (match.featured_image && imgEl) {
        var varImg = typeof match.featured_image === 'string'
          ? match.featured_image
          : match.featured_image.src;
        imgEl.src = varImg;
      }
    }
  }

  function updatePricing(variant) {
    if (priceMainEl) {
      priceMainEl.textContent = '₹' + formatMoney(variant.price);
    }
    if (priceCompareEl) {
      if (variant.compare_at_price > variant.price) {
        priceCompareEl.textContent = '₹' + formatMoney(variant.compare_at_price);
        priceCompareEl.style.display = 'inline';
      } else {
        priceCompareEl.textContent = '';
        priceCompareEl.style.display = 'none';
      }
    }
    if (discountPillEl) {
      if (variant.compare_at_price > variant.price) {
        var pct = Math.round(((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100);
        discountPillEl.textContent = pct + '% OFF';
        discountPillEl.style.display = 'inline-block';
      } else {
        discountPillEl.textContent = '';
        discountPillEl.style.display = 'none';
      }
    }
  }

  function updateATC(variant) {
    if (atcBtn) {
      atcBtn.disabled = !variant.available;
      atcBtn.textContent = variant.available ? 'Add to Cart' : 'Sold Out';
    }
    if (buyNowBtn) {
      buyNowBtn.disabled = !variant.available;
    }
  }

  /* ── PINCODE CHECKER ── */
  function handlePincode() {
    if (!pinInputEl || !pinEtaEl) return;
    var pin = pinInputEl.value.trim();
    if (pin.length !== 6 || isNaN(pin)) {
      pinEtaEl.textContent = 'Please enter a valid 6-digit pincode.';
      pinEtaEl.className = 'aona-qv__pin-eta is-error';
      pinEtaEl.hidden = false;
      return;
    }
    var d = new Date();
    d.setDate(d.getDate() + 5);
    var dateStr = d.toLocaleDateString('en-IN', { day: 'numeric', month: 'short' });
    pinEtaEl.textContent = '✔ Delivered by ' + dateStr + ' · COD Available';
    pinEtaEl.className = 'aona-qv__pin-eta is-success';
    pinEtaEl.hidden = false;
  }

  /* ── QUANTITY ── */
  function updateQty(delta) {
    currentQty = Math.max(1, currentQty + delta);
    if (qtyValEl) qtyValEl.textContent = currentQty;
  }

  /* ── ATC & BUY NOW ── */
  function handleATC(e) {
    if (e) e.preventDefault();
    if (!currentVariant || !currentVariant.available) return;

    var isAuth = (typeof window.aonaIsUserAuthenticated === 'function') ? window.aonaIsUserAuthenticated() : (window.aonaCustomerLoggedIn === true);
    if (!isAuth) {
      hideModal();
      if (typeof window.aonaEnforceAuthAndRedirect === 'function') {
        window.aonaEnforceAuthAndRedirect(currentVariant.id, currentQty, false);
      } else {
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: currentVariant.id, quantity: currentQty })
        }).finally(function() {
          window.location.href = '/account/login?checkout_url=' + encodeURIComponent('/cart') + '&return_to=' + encodeURIComponent('/cart');
        });
      }
      return;
    }

    atcBtn.disabled = true;
    atcBtn.textContent = 'Adding…';

    var addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add.js';

    fetch(addUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: currentVariant.id, quantity: currentQty })
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        atcBtn.textContent = '✓ Added to Cart';
        fetch('/cart.js')
          .then(function (r) { return r.json(); })
          .then(function (cartData) {
            var badges = document.querySelectorAll('.aona-header-action-item span[style*="border-radius: 50%"], .cart-count-badge, .cart-count-bubble-sticky, .cart-count');
            badges.forEach(function (b) { b.textContent = cartData.item_count; });
          })
          .catch(function () {});
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        setTimeout(function () {
          updateATC(currentVariant);
          hideModal();
        }, 1200);
      })
      .catch(function () {
        atcBtn.textContent = 'Try again';
        atcBtn.disabled = false;
      });
  }

  function handleBuyNow(e) {
    if (e) e.preventDefault();
    if (!currentVariant || !currentVariant.available) return;

    var isAuth = (typeof window.aonaIsUserAuthenticated === 'function') ? window.aonaIsUserAuthenticated() : (window.aonaCustomerLoggedIn === true);
    if (!isAuth) {
      hideModal();
      if (typeof window.aonaEnforceAuthAndRedirect === 'function') {
        window.aonaEnforceAuthAndRedirect(currentVariant.id, currentQty, true);
      } else {
        try {
          sessionStorage.setItem('aona_pending_buy_now', 'true');
          document.cookie = 'aona_buy_now=true; path=/; max-age=600; SameSite=Lax';
          sessionStorage.setItem('aona_pending_cart_action', JSON.stringify({ id: currentVariant.id, quantity: currentQty, isBuyNow: true }));
        } catch(e) {}
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: currentVariant.id, quantity: currentQty })
        }).finally(function() {
          window.location.href = '/account/login?checkout_url=' + encodeURIComponent('/checkout') + '&return_to=' + encodeURIComponent('/checkout');
        });
      }
      return;
    }

    buyNowBtn.disabled = true;
    buyNowBtn.textContent = 'Preparing Checkout…';

    var addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add.js';
    var cartUrl = (window.routes && window.routes.cart_url) || '/cart';

    fetch(addUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: currentVariant.id, quantity: currentQty })
    })
      .then(function () {
        buyNowBtn.disabled = false;
        buyNowBtn.textContent = 'Buy Now';
        hideModal();

        // Check if address exists — prompt if missing, then route to Shopify Native Checkout
        var hasAddr = false;
        try {
          var rawAddr = localStorage.getItem('aona_shipping_address') || sessionStorage.getItem('aona_shipping_address');
          if (rawAddr) {
            var parsed = JSON.parse(rawAddr);
            if (parsed && parsed.address1 && parsed.zip) hasAddr = true;
          }
        } catch(e) {}

        if (!hasAddr && typeof window.aonaOpenAddressModal === 'function') {
          window.aonaOpenAddressModal(function(addr) {
            window.location.href = window.aonaGetCheckoutUrl ? window.aonaGetCheckoutUrl(addr) : '/checkout';
          });
        } else {
          window.location.href = window.aonaGetCheckoutUrl ? window.aonaGetCheckoutUrl() : '/checkout';
        }
      })
      .catch(function () {
        buyNowBtn.disabled = false;
        buyNowBtn.textContent = 'Buy Now';
        window.location.href = window.aonaGetCheckoutUrl ? window.aonaGetCheckoutUrl() : '/checkout';
      });
  }

  /* ── MODAL STATE ── */
  function showModal() {
    modal.hidden = false;
    document.body.style.overflow = 'hidden';
  }
  function hideModal() {
    if (modal) modal.hidden = true;
    document.body.style.overflow = '';
    currentProduct = null;
  }
  function showLoading() {
    if (loading) loading.style.display = 'flex';
    if (content) content.hidden = true;
  }
  function showContent() {
    if (loading) loading.style.display = 'none';
    if (content) content.hidden = false;
  }

  /* ── INIT ── */
  function init() {
    modal          = document.getElementById('aona-qv');
    backdrop       = document.getElementById('aona-qv-backdrop');
    closeBtn       = document.getElementById('aona-qv-close');
    loading        = document.getElementById('aona-qv-loading');
    content        = document.getElementById('aona-qv-content');
    imgEl          = document.getElementById('aona-qv-img');
    thumbsEl       = document.getElementById('aona-qv-thumbs');
    titleEl        = document.getElementById('aona-qv-title');
    colEl          = document.getElementById('aona-qv-collection');
    reviewsLink    = document.getElementById('aona-qv-reviews-link');
    priceMainEl    = document.getElementById('aona-qv-price-main');
    priceCompareEl = document.getElementById('aona-qv-price-compare');
    discountPillEl = document.getElementById('aona-qv-discount-pill');
    descEl         = document.getElementById('aona-qv-desc');
    variantsEl     = document.getElementById('aona-qv-variants');
    variantIdEl    = document.getElementById('aona-qv-variant-id');
    pinInputEl     = document.getElementById('aona-qv-pin-input');
    pinBtnEl       = document.getElementById('aona-qv-pin-btn');
    pinEtaEl       = document.getElementById('aona-qv-pin-eta');
    qtyMinusBtn    = document.getElementById('aona-qv-qty-minus');
    qtyPlusBtn     = document.getElementById('aona-qv-qty-plus');
    qtyValEl       = document.getElementById('aona-qv-qty-val');
    atcBtn         = document.getElementById('aona-qv-atc');
    buyNowBtn      = document.getElementById('aona-qv-buynow');
    fullLinkEl     = document.getElementById('aona-qv-full-link');

    if (backdrop) backdrop.addEventListener('click', hideModal);
    if (closeBtn) closeBtn.addEventListener('click', hideModal);
    if (atcBtn)   atcBtn.addEventListener('click', handleATC);
    if (buyNowBtn) buyNowBtn.addEventListener('click', handleBuyNow);
    if (pinBtnEl) pinBtnEl.addEventListener('click', handlePincode);
    if (qtyMinusBtn) qtyMinusBtn.addEventListener('click', function () { updateQty(-1); });
    if (qtyPlusBtn) qtyPlusBtn.addEventListener('click', function () { updateQty(1); });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal && !modal.hidden) hideModal();
    });

    wireButtons();

    var observer = new MutationObserver(wireButtons);
    observer.observe(document.body, { childList: true, subtree: true });
  }

  /* ── WIRE BUTTONS ── */
  function wireButtons() {
    document.querySelectorAll('[data-aona-qv-url]:not([data-qv-wired])').forEach(function (btn) {
      btn.setAttribute('data-qv-wired', '1');
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        open(btn.dataset.aonaQvUrl);
      });
    });

    document.querySelectorAll('.quick-view:not([data-qv-wired])').forEach(function (btn) {
      btn.setAttribute('data-qv-wired', '1');
      btn.addEventListener('click', function (e) {
        var url = btn.dataset.productUrl || btn.closest('[data-product-url]')?.dataset.productUrl;
        if (!url) return;
        e.preventDefault();
        e.stopPropagation();
        open(url.replace(/\.js$/, ''));
      }, true);
    });
  }

  function formatMoney(cents) {
    return (cents / 100).toLocaleString('en-IN', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    });
  }

  window.aonaQuickView = { open: open, close: hideModal };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
